export const windowStoredPollFlight = "wcbPollFlight";

export interface FlightInformation {
  relaxedTryWaitTime: boolean;
  increasedPollFrequency: boolean;
  disableRetries: boolean;
  usePollingAndEventing: boolean;
  useLocalStorageWrapper: boolean;
  useCachedLocalStorageKeys: boolean;
  useLocalStorageKeyApi: boolean;
  useOnlyEventing: boolean;
  publishIndexedDB: boolean;
  receieveIndexedDB: boolean;
}

let flightDetailsPromise: Promise<FlightInformation>;
export function getFlightDetails(): Promise<FlightInformation> {
  if (!flightDetailsPromise) {
    flightDetailsPromise = new Promise<FlightInformation>((resolve) => {
      let interval = window.setInterval(() => {
        let unparsedFlightInfo = window.localStorage.getItem(windowStoredPollFlight);
        if (unparsedFlightInfo) {
          resolve(JSON.parse(unparsedFlightInfo));
          window.clearInterval(interval);
        }
      }, 500);
    });
  }
  return flightDetailsPromise;
}
